const ALERT_DIALOG_ACTIONS = {
  openAlertDialog: 'ALERT_DIALOG_OPENED',
  closeAlertDialog: 'ALERT_DIALOG_CLOSED',
  confirmYes: 'CONFIRM_YES',
};

export default ALERT_DIALOG_ACTIONS;
